module.exports = __webpack_public_path__ + "3e7a0d879874c457ba71ef94c6603b13.png";